interface Suggestion {
  label: string;
  value: string;
  date: Date;
}

export const pad = (n: number): string => n < 10 ? `0${n}` : `${n}`;

export const formatDate = (d: Date): string => {
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export const getWeekdayLabel = (day: number): string => {
  const days = [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
  ];
  return days[day];
}

export const getScheduleSuggestions = (now = new Date()): Suggestion[] => {
  const suggestions: Suggestion[] = [];
  const today = new Date(now);
  const morning = new Date(today);
  morning.setHours(8, 0, 0, 0);
  const afternoon = new Date(today);
  afternoon.setHours(13, 0, 0, 0);
  const isBeforeMorning = now.getTime() < morning.getTime();
  const isBeforeAfternoon = now.getTime() < afternoon.getTime();
  if (isBeforeMorning || isBeforeAfternoon) {
    if (isBeforeMorning) {
      suggestions.push({
        label: 'Esta manhã',
        value: formatDate(morning),
        date: morning,
      });
    }
    if (isBeforeAfternoon) {
      suggestions.push({
        label: 'Esta tarde',
        value: formatDate(afternoon),
        date: afternoon,
      });
    }
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const tomorrowMorning = new Date(tomorrow);
    tomorrowMorning.setHours(9, 0, 0, 0);
    const tomorrowAfternoon = new Date(tomorrow);
    tomorrowAfternoon.setHours(13, 0, 0, 0);
    const labelBase = getWeekdayLabel(tomorrow.getDay());
    if (suggestions.length < 3) {
      suggestions.push({
        label: `${labelBase} de manhã`,
        value: formatDate(tomorrowMorning),
        date: tomorrowMorning,
      });
    }
    if (suggestions.length < 3) {
      suggestions.push({
        label: `${labelBase} de tarde`,
        value: formatDate(tomorrowAfternoon),
        date: tomorrowAfternoon,
      });
    }
  } else {
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const afterTomorrow = new Date(today);
    afterTomorrow.setDate(today.getDate() + 2);
    const tomorrowMorning = new Date(tomorrow);
    tomorrowMorning.setHours(9, 0, 0, 0);
    const tomorrowAfternoon = new Date(tomorrow);
    tomorrowAfternoon.setHours(13, 0, 0, 0);
    const afterTomorrowMorning = new Date(afterTomorrow);
    afterTomorrowMorning.setHours(9, 0, 0, 0);
    const labelTomorrow = getWeekdayLabel(tomorrow.getDay());
    const labelAfterTomorrow = getWeekdayLabel(afterTomorrow.getDay());
    suggestions.push(
      {
        label: `${labelTomorrow} de manhã`,
        value: formatDate(tomorrowMorning),
        date: tomorrowMorning,
      },
      {
        label: `${labelTomorrow} de tarde`,
        value: formatDate(tomorrowAfternoon),
        date: tomorrowAfternoon,
      },
      {
        label: `${labelAfterTomorrow} de manhã`,
        value: formatDate(afterTomorrowMorning),
        date: afterTomorrowMorning,
      }
    );
  }
  return suggestions;
}
